import { useQuery, gql } from '@apollo/client';
import React from 'react';
import Page from '../../../components/page';
import { GQLTour } from 'townapps-models';
import TourHikes from '../../../components/listings/tourHikes';
import client from '../../../utils/apolloClient';
import useLogView from '../../../hooks/useLogView';

const GET_ITEMS = gql`
  query Items($appId: String!) {
    tours: tour(appId: $appId) {
      id
      title
      description
      time
      distance
      image
      dataset
      latitude
      longitude
      tags
      gallery
      attractions
      type
      slug
    }
  }
`;

const GET_SLUG = gql`
  query getData($slug: String) {
    app: getApp(slug: $slug) {
      id
      name
      slug
      sponsoredLogo
      firstSponsor
      secondSponsor
      thirdSponsor
      fourthSponsor
      fifthSponsor
      sixthSponsor
      cards {
        tour {
          title
        }
      }
    }
  }
`;

const Tours = ({ app }) => {
  const { data } = useQuery<{ tours: GQLTour[] }>(GET_ITEMS, { variables: { appId: app.id } });
  useLogView(undefined, app?.id, 'ToursListing');

  return (
    <Page>
      <TourHikes
        app={app}
        title="Turais Féin-treoraithe / Self Guided Tours"
        subtitle={`The best way to get to know ${app.name} is on foot. Take a self-guided walking tour.`}
        pathname={'tour'}
        items={data ? data.tours : []}
      />
    </Page>
  );
};

Tours.getInitialProps = async ({ query }) => {
  const apolloClient = client;
  const { data } = await apolloClient.query({
    query: GET_SLUG,
    variables: {
      slug: query.slug.toLowerCase(),
    },
  });

  return {
    app: data?.app,
  };
};

export default Tours;
